import { NgModule } from '@angular/core';
import { MsLogoComponent } from './ms-logo.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsLogoComponent],
	imports: [SharedLibsModule],
	exports: [MsLogoComponent],
	providers: [],
})
export class MsLogoModule {}
